<template>
  <div class="map-list">
    <div class="row expanded small-collapse top-of-content">
      <div class="columns small-12">

        <!-- Hero Image -->
        <div class="o-listing-hero u-bg-img pos-rel" :style="'background-image: url(' + image + ');'" :alt="title + ' in Waterford'" v-if="image">
          <div>
            <h2 class="o-listing-hero__title columns small-12 large-12 end">
              {{ title }}
            </h2>
          </div>

          <div class="o-photo-credit-wrapper hero" v-if="photoname">
            <div class="o-photo-credit">
              <div class="o-photo-credit__text" id="photo-credit" data-toggler=".expanded">
                <h4>{{ photoname }}, {{photolocation}}</h4>
                <span>Photographer: {{photographer}}</span>
              </div>

              <div class="o-photo-credit__button">
                <a href="#" a data-toggle="photo-credit" class="photo-credit-stop"><i class="icon ion-ios-information-outline"></i></a>
              </div>
            </div>
          </div>
        </div>

        <div class="u-bg-white">
          <div class="o-listing-filter">
            <div class="hide-for-small-only o-listing-filter__large">
              <div class="o-listing-filter__pane">
                <div class="row">

                  <!-- Category Select -->
                  <div class="columns medium-4">
                    <div class="o-listing-filter__filter-large o-listing-filter__filter-large-dropdown">
                      <select class="o-listing-filter__filter-large-select" v-model="category">
                        <option value="all" selected>All</option>
                        <option v-for="cat in categories" :value="cat.slug" v-html="cat.name"></option>
                      </select>
                    </div>
                  </div>

                  <!-- Keyword Filter -->
                  <div class="columns medium-3">
                    <div class="o-listing-filter__filter-large">
                      <input @keyup="filterAll" v-model="keywords" class="o-listing-filter__filter-large-text" type="text" value="" name="search" placeholder="Keyword">
                    </div>
                  </div>

                  <!-- Locations Filter -->
                  <div class="columns medium-3">
                    <div class="o-listing-filter__filter-large o-listing-filter__filter-large-dropdown">
                      <select class="o-listing-filter__filter-large-select" v-model="location">
                        <option value="all">All Locations</option>
                        <option v-for="loc in locations" :value="loc.slug">
                          {{ loc.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Clear Button -->
                  <div class="columns medium-2">
                      <button @click="resetAllFilters" class="button pos-rel" type="button">Clear</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="filter-bar--mobile-container show-for-small-only">
              <div class="o-listing-filter">
                <div class="o-listing-filter__mobile-container">
                  <div class="row">
                    <div class="columns small-10 small-centered">
                      <ul data-accordion data-allow-all-closed="true" class="accordion filter-bar show-for-small-only" role="tablist">
                        <li data-accordion-item="" >
                          <a href="#"  role="tab"  >
                            <div class="o-listing-filter__toggle-container">
                              <button type="button" class="o-listing-filter__toggle">
                                Filter by<i class="icon ion-android-arrow-dropdown"></i>
                              </button>
                            </div>
                          </a>
                          <div data-tab-content class="accordion-content o-listing-filter__pane" role="tabpanel">
                            <div class="o-listing-filter__filter-space"><label for="subject">Category</label>
                              <p><select class="filter-bar--input" v-model="category">
                                  <option value="all">All</option>
                                  <option v-for="cat in categories" :value="cat.slug" v-html="cat.name"></option>
                                </select>
                              </p>
                            </div>
                            <div class="o-listing-filter__filter-space"><label for="subject">Search</label>
                              <p><input @keyup="filterAll" v-model="keywords" class="filter-bar--input" type="text" value="" name="search" placeholder="Keyword"></p>
                            </div>
                            <div class="o-listing-filter__filter-space"><label for="subject">Near</label>
                              <p>
                                <select class="filter-bar--input" v-model="location">
                                  <option value="all">All Locations</option>
                                  <option v-for="loc in locations" :value="loc.slug">
                                    {{ loc.name }}
                                  </option>
                                </select>
                              </p>
                            </div>
                            <div class="o-listing-filter__filter-button small-12 u-center">
                              <button @click="resetAllFilters" class="button" type="button pos-rel">Clear</button>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        </div>
        <div class="row c-block  o-listing-card--landing-container u-bg-texture">
          <div class="columns small-12">

            <!-- Count and perpage settings -->
            <div class="row small-collapse" style="padding-bottom: 25px;">
              <div class="columns small-6">
                <h4 class="h-listings">{{ filteredList.length }} Listings</h4>
              </div>
              <div class="columns small-6 medium-4 large-3">
                <div class="o-listing-filter__filter-large o-listing-filter__filter-large-dropdown pos-rel" style="background-color: rgba(255, 255, 255, 0);">
                  <select class="o-listing-filter__filter-large-select" v-model="numberMethod" style="background-color: rgba(255, 255, 255, 0);">
                    <option v-for="method in numberMethods" :value="method.slug">
                      {{ method.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Listings -->
            <div class="row expanded small-collapse">
              <div class="columns small-12">

                <paginate
                  :list="filteredList"
                  :per="perPage"
                  class="row small-up-1 medium-up-3"
                  v-if="filteredList.length"
                  name="listings"
                  data-equalizer="listing-cards" data-equalizer-on="medium" data-equalize-by-row="true">

                    <div
                      :key="index"
                      v-for="(listing, index) in paginated('listings')"
                      class="column column-block">
                      <listing-card-portrait :content="listing"></listing-card-portrait>
                    </div>
                </paginate>

              </div>
            </div>

            <!-- Load More -->
            <div class="txtalign--load">
              <div class="row">
                <div class="columns small-12" style="text-align: center;">
                  <button class="button" v-if="hasMoreItems && filteredList.length" @click="loadMore">
                    <span class="button__text">Load More</span>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>

  import Gmap from './vue-partials/gmap.vue';
  import ListingCard from './vue-partials/listing-card.vue';

  export default {

    name: 'FilterList',

    props: {
      providedList: {
        type: Array,
      },
      title: {
        type: String
      },
      image: {
        type: String
      },
      photoname: {
        type: String
      },
      photolocation: {
        type: String
      },
      photographer: {
        type: String
      },
      imagealt: {
        type: String
      },
      type: {
        type: String
      },
      preSelectCat: {
        type: String
      }
    },

    data () {
      return {

        /**
        * Bound to our search input
        * @type {String}
        */
        keywords: '',

        listings: [],

        /**
        * How many to display per page
        * This can be changed and pagination updated on the fly
        * @type {Number}
        */
        perPage: 9,

        /**
        * What list do we paginate
        * @type {Array}
        */
        paginate: ['listings'],

        /**
        * Will be generated from the passed in Listings
        * @type {Array}
        */
        locations: [],

        /**
        * The selected locoation - bound to the location select
        * @type {String}
        */
        location: '',

        /**
        * Will be generated from the passed in listings
        * @type {Array}
        */
        categories: [],

        /**
        * Will be generated from the passed in listings
        * @type {Array}
        */
        types: [],

        /**
        * The selected category - bound to the category select
        * @type {String}
        */
        category: '',

        /**
        * This will contain our filtered listings
        * @type {Array}
        */
        filteredList: [],

        isReady: false,

        /**
        * The selected sort method - bound to the sort select
        * @type {String}
        */
        numberMethods: [
          {
            'name': 'View 9 per page',
            'slug': '9pp',
            'desc': 'View 9 cards per page'
          },
          {
            'name': 'View 18 per page',
            'slug': '18pp',
            'desc': 'View 18 cards per page'
          },
          {
            'name': 'View 36 per page',
            'slug': '36pp',
            'desc': 'View 36 cards per page'
          },
          {
            'name': 'View 99 per page',
            'slug': '99pp',
            'desc': 'View 99 cards per page'
          }
        ],

        /**
        * The selected sort method - bound to the sort select
        * @type {String}
        */
        numberMethod: '9pp',
      };
    },

    computed:{
      hasMoreItems () {
        return this.filteredList.length > this.perPage;
      }
    },

    watch: {
      // we want to watch the category and keywords variables
      // and call `filterAll()` on either of them changing
      // this will ensure both filters are applied
      category () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      location () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      keywords () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },
      numberMethod () {
        this.sortFilteredList();

        this.$nextTick(() => {
          this.callFoundation();
        });
      }
    },

    mounted () {

      if (this.type == "") {
        this.type = "things-to-do";
      }

      this.listings = this.providedList;
      this.categories = this.getCategoriesFromListings();
      this.locations = this.getLocationsFromListings();

      // Reset app on mounted
      this.resetAllFilters();

      // Is there query params?
      if (window.location.search) {

        //IE FIXES
        var queryString = window.location.search;
        let listingPreFilter = this.parseQueryString(queryString);
        // parseQueryString(queryString);
        if (typeof(listingPreFilter.type) !== "undefined") {
          this.type = listingPreFilter.type;
          console.log('In type');
        }

        if (typeof(listingPreFilter.category) !== "undefined") {
          this.category = listingPreFilter.category;
          console.log('In category');
        }

        if (typeof(listingPreFilter.search) !== "undefined") {
          this.keywords = listingPreFilter.search;
          console.log('In search');
        }

        if (typeof(listingPreFilter.near) !== "undefined") {
          this.location = listingPreFilter.near;
          console.log('In near');
        }
      }

      // Check if category has been passed
      if (this.preSelectCat != "") {
        this.category = this.preSelectCat;
      }
    },

    methods: {
      // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
          // Foundation.reInit('data-accordion')
        })
      },

      // Parse url with query string
      parseQueryString(queryString) {
        var params = {}, queries, temp, i, l;
        // Split into key/value pairs
        queries = queryString.replace('?','');
        queries = queries.split("&");
        // Convert the array of strings into an object
        for ( i = 0, l = queries.length; i < l; i++ ) {
          temp = queries[i].split('=');
          params[temp[0]] = temp[1];
          // console.log(temp);
        }
        return params;
      },

      // Load More
      loadMore () {
        // let currentPageHeight = this.$el.offsetHeight;
        // let newPageHeight = 0;

        this.perPage = this.perPage + 6;

        this.$nextTick(() => {
          // newPageHeight = this.$el.offsetHeight;
          // window.scroll(0, (newPageHeight - currentPageHeight) + 200);
          this.callFoundation();
          Foundation.reInit($('[data-equalizer]'));
        });
      },

      /**
      * Convert a title to url title
      * @param {title}
      * @return {url_title}
      */
      titleToUrlTitle (title) {
        return title
        .toLowerCase()
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-');
      },

      /**
      * Filter everything
      * @return {void}
      */
      filterAll () {
        this.isReady = false;

        // reset the list to all listings first
        this.filteredList = this.listings;
        this.filterByKeywords();
        this.filterByCategory();
        this.filterByLocation();

        this.isReady = true;
      },

      /**
      * Reset the list back to it's initial state
      * This will trigger the filters and show everything
      * @return {void}
      */
      resetAllFilters () {
        this.callFoundation();

        this.filteredList = this.listings;
        this.keywords = ''; // initial state is to show all categories
        this.category = 'all'; // initial state is to show all categories
        this.location = 'all'; // initial state is to show all locations
        this.type = 'all'; // initial state is to show all locations
      },

      getCategoriesFromListings ($items = this.listings) {
        let appScope = this;

        let categories = $items.map(listing => {
          if (appScope.type != 'all') {
            return listing.categories.filter(category => {
              return category['category_parent_slug'] === appScope.type;
            });
          } else {
            return listing.categories;
          }
        });

        // horrible name, horrible, but we need to flatten those categories
        // Haha flat kitties, only kidding, we love cats here.
        let flatCats = [].concat.apply([], categories);

        // Generate unique objects
        flatCats = flatCats.filter((obj, pos, arr) => {
          return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
        });

        return flatCats.sort(function( a, b ){
          return a.name > b.name ? 1 : -1;
        });
      },

      /**
      * Go through all supplied listings and get the locations
      * @return {array}
      */
      getLocationsFromListings () {

        let locations = this.listings.map(listing => {
          return listing.locations;
        });

        // horrible name, horrible, but we need to flatten those categories
        let flatCats = [].concat.apply([], locations);


        // Generate unique objects
        flatCats = flatCats.filter((obj, pos, arr) => {
          return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
        });

        return flatCats.sort(function( a, b ){
          return a.name > b.name ? 1 : -1;
        });
      },

      /**
      * Filter the list from the free text search
      * Nothing too fancy, but it works
      * @return {void}
      */
      filterByKeywords () {
        if (!this.keywords) {
          return;
        }

        this.filteredList = this.filteredList.filter(listing => {
          // bringing everything to lowercase to make comparisons more reliable
          // i.e., "Search" !== "search"
          let listingName = listing.title.toLowerCase();
          let searchQuery = this.keywords.toLowerCase();

          if (searchQuery !== '') {
            this.resetVisible = true;
          }

          return listingName.indexOf(searchQuery) !== -1;
        });
      },

      /**
      * Filter the list by category
      * @return {void}
      */
      filterByCategory () {
        if (!this.category) {
          return;
        }

        if (this.category !== 'all') {
          this.filteredList = this.filteredList.filter(listing => {
            this.resetVisible = true;

            let thisListing = listing;

            let targetCategory = this.category;

            return thisListing.categories.map(cat => cat.slug).indexOf(targetCategory) !== -1;
          });
        }
      },

      /**
      * Filter the list by location
      * @return {void}
      */
      filterByLocation () {
        if (!this.location) {
          return;
        }

        if (this.location !== 'all') {
          this.filteredList = this.filteredList.filter(listing => {
            this.resetVisible = true;

            let thisListing = listing;

            let targetLocation = this.location;

            return thisListing.locations.map(loc => loc.slug).indexOf(targetLocation) !== -1;
          });
        }
      },

      sortFilteredList () {
        if (!this.numberMethod) {
          return;
        }

        if (this.numberMethod !== 'none') {

          switch ( this.numberMethod ) {
            case '9pp':
              this.perPage = 9;
              break;
            case '36pp':
              this.perPage = 18;
              break;

            case '16pp':
              this.perPage = 36;
              break;

            case '99pp':
              this.perPage = 99;
              break;
          }

        }
      },

    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/filter-list.vue